<template lang="pug">
div
    SearchWrapper(v-if="$search[data._uid]" :parentId="data._uid" :searchContext="$search[data._uid]" :key="data._uid")
        template(v-if="data.sections")
            template(v-for="widget in data.sections")
                slot(:data="widget")

</template>

<script>
import SearchWrapper from '@/components/search/wrapper'

export default {
    name: 'SearchWrapperWidget',
    components: {
        SearchWrapper,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
}
</script>
